(function () {
  class SlUserTestimonials extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.slider = this.querySelector('[data-sl-user-testimonials-slider]');
      this.progressTrack = this.querySelector('.sl-user-testimonials__progress');
      this.progressFill = this.querySelector('[data-sl-user-testimonials-progress-fill]');
      this.prevButton = this.querySelector('[data-sl-user-testimonials-prev]');
      this.nextButton = this.querySelector('[data-sl-user-testimonials-next]');
      this.boundUpdateProgress = this.updateProgress.bind(this);

      if (!this.slider || typeof window.Swiper === 'undefined') return;

      this.swiper = new window.Swiper(this.slider, {
        slidesPerView: 'auto',
        spaceBetween: 18,
        speed: 600,
        watchOverflow: true,
        navigation:
          this.prevButton && this.nextButton
            ? {
                nextEl: this.nextButton,
                prevEl: this.prevButton
              }
            : false,
        breakpoints: {
          0: {
            slidesPerView: 'auto',
            spaceBetween: 16
          },
          1025: {
            slidesPerView: 'auto',
            spaceBetween: 18
          }
        },
        on: {
          init: () => this.updateProgress(),
          resize: () => this.updateProgress(),
          setTranslate: () => this.updateProgress(),
          transitionEnd: () => this.updateProgress()
        }
      });

      window.addEventListener('resize', this.boundUpdateProgress);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundUpdateProgress);
      this.swiper?.destroy?.(true, true);
    }

    updateProgress() {
      if (!this.progressTrack || !this.progressFill || !this.swiper) return;

      const snapCount = this.swiper.snapGrid?.length || 0;
      if (snapCount <= 1) {
        this.progressFill.style.width = '100%';
        this.progressFill.style.transform = 'translateX(0px)';
        return;
      }

      const visibleRatio = Math.min(1, this.swiper.width / this.swiper.virtualSize);
      const trackWidth = this.progressTrack.clientWidth || 100;
      const thumbWidth = Math.max(24, visibleRatio * trackWidth);
      const minTranslate = this.swiper.minTranslate ? this.swiper.minTranslate() : 0;
      const maxTranslate = this.swiper.maxTranslate ? this.swiper.maxTranslate() : 0;
      const translateRange = minTranslate - maxTranslate;
      let progress = 0;

      if (translateRange > 0) {
        progress = (minTranslate - this.swiper.translate) / translateRange;
      }

      progress = Math.min(1, Math.max(0, progress));
      const travel = Math.max(0, trackWidth - thumbWidth);

      this.progressFill.style.width = `${thumbWidth}px`;
      this.progressFill.style.transform = `translateX(${travel * progress}px)`;
    }
  }

  if (!customElements.get('sl-user-testimonials')) {
    customElements.define('sl-user-testimonials', SlUserTestimonials);
  }
})();
